import React from "react";
import EditableInput from "./EditableInput";

const ArrayEditor = ({
  entry,
  arrayItems,
  onAddItem,
  onRemoveItem,
  onChangeItem,
}) => (
  <div className="space-y-3 rounded-2xl border border-slate-800/90 bg-slate-950/40 p-4">
    <div className="flex items-center justify-between gap-3">
      <p className="text-xs text-slate-400">Edit one item per row.</p>
      <button
        type="button"
        onClick={onAddItem}
        className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
        aria-label={`Add ${entry.label} item`}
      >
        Add item
      </button>
    </div>

    {arrayItems.length ? (
      arrayItems.map((item, index) => (
        <div
          key={`${entry.key}-item-${index}`}
          className="rounded-2xl border border-slate-800 bg-slate-900/60 p-3"
        >
          <div className="mb-2 flex items-center justify-between gap-3">
            <span className="text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
              Item {index + 1}
            </span>
            <button
              type="button"
              onClick={() => onRemoveItem(index)}
              className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-2.5 py-1.5 text-[11px] font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white"
              aria-label={`Remove ${entry.label} item ${index + 1}`}
            >
              Remove
            </button>
          </div>

          <EditableInput
            value={item.textValue ?? ""}
            onChange={(event) => onChangeItem(index, event.target.value)}
            multiline={item.mode === "json"}
            rows={item.mode === "json" ? 6 : 3}
            ariaLabel={`${entry.label} item ${index + 1}`}
            placeholder={item.mode === "json" ? "Enter valid JSON for this item" : ""}
          />
        </div>
      ))
    ) : (
      <div className="rounded-2xl border border-dashed border-slate-700 px-4 py-4 text-sm text-slate-400">
        No items yet.
      </div>
    )}
  </div>
);

export default ArrayEditor;
